import type { Nullable } from '@ats/interfaces';
import type { Socket } from 'socket.io';
import { io } from 'socket.io-client';

export class SocketClient {
  private static instance: Nullable<SocketClient> = null;
  private socket: Nullable<Socket> = null;

  private constructor(namespace?: string) {
    this.socket = this.createSocket(namespace) as unknown as Socket;
    SocketClient.instance = this;
  }

  private createSocket(namespace?: string) {
    const baseUrl = import.meta.env.DEV ? import.meta.env.VITE_API_URL : '';
    const space = namespace ? `/${namespace}` : '/';

    console.log(`${baseUrl}${space}`);

    return io(`${baseUrl}${space}`, {
      forceNew: true,
      timeout: 10000,
      transports: ['websocket'],
    });
  }

  public static getInstance(namespace?: string): SocketClient {
    if (!SocketClient.instance) {
      SocketClient.instance = new SocketClient(namespace);
    }

    return SocketClient.instance;
  }

  public getSocket(): Socket {
    return this.socket!;
  }

  public emit(key: string, value: string) {
    this.socket?.emit(key, value);
  }

  public on(key: string, cb: (data: any) => void) {
    this.socket?.on(key, cb);
  }

  public close() {
    this.socket?.disconnect();
  }
}
